var _style, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 882.2 882.2",
    style: {
      enableBackground: "new 0 0 882.2 882.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.2143,
    y1: 297.1088,
    x2: 883.4299,
    y2: 297.1088,
    gradientTransform: "matrix(1 0 0 1 0 144.7778)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#513EFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#5157FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#5298FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#52E5FF"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 442.8,
    cy: 441.9,
    r: 440.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M217.7,262.2c6.3-11.9,15.5-22,26.7-29.4l187.4-131.4l-192,318.5c0,0-16.8-28.5-23.4-42.8 C200,340.3,200.5,298.3,217.7,262.2L217.7,262.2z M140.4,481.8c4.2,61.6,34.8,118.4,83.9,155.7l207.3,145 c0,0-129.6-187.5-239.1-374.1c-11.1-19.7-18.6-41.3-22-63.6c-1.5-10.1-1.5-20.4,0-30.6c-2.8,5.3-8.4,16.2-8.4,16.2 c-11.1,22.8-18.7,47-22.4,72C137.5,428.9,137.8,455.4,140.4,481.8z M668.8,507.1c-6.7-14.3-23.4-42.8-23.4-42.8L453.8,782.5 l187.4-131.1c11.1-7.5,20.3-17.6,26.7-29.4c17.3-36.2,17.7-78.3,1.2-114.9L668.8,507.1z M744.9,402.2 c-4.2-61.6-34.8-118.4-83.9-155.7L454.1,101.3c0,0,129.6,187.5,239,374.1c11,19.7,18.4,41.3,21.9,63.6c1.5,10.1,1.5,20.4,0,30.6 c2.8-5.3,8.4-16.2,8.4-16.2c11.1-22.8,18.7-47,22.4-72c2.2-26.5,2-52.9-0.6-79.4L744.9,402.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnsIcon);
export default __webpack_public_path__ + "static/media/ens_icon.578554630bc05109436790471f90414f.svg";
export { ForwardRef as ReactComponent };